// @flow
import React, { Component } from 'react';
import type { Dispatch } from 'redux';
import { connect } from '../../base/redux';
import { API_STUDENT_WAIT_INTERVAL, FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../constant';
import { messages } from '../welcome-dashboard/messages';
import { getRoomStatus } from '../welcome-dashboard/Request.d';
/**
 * The type of the React {@code Component} props of {@link StudentWaitingPage}
 */
type Props = {

    dispatch: Dispatch<any>
}

/**
 * A React component that implements tabs.
 *
 */

class StudentWaitingPage extends Component<Props> {
    /**
     * Destroys the local tracks (if any) since no media is desired when this
     * component is rendered.
     *
     * @inheritdoc
     * @returns {void}
     */


    /**
     * Initializes a new {@code StudentWaitingPage} instance.
     *
     * @inheritdoc
     */
    constructor(props: Props) {
        super(props);

        this.state = {
            teacherDetail: {},
            businessDetail: {},
        }
    }


    componentDidMount() {

        // Check if the teacher is connected or not
        // api implemented on temp basis, will find

        var _this = this;
        let waitTimer = setInterval(async function () {
            var { tokenDecodedData, authOrganization, setWaitinStatus } = _this.props;
            if (tokenDecodedData && tokenDecodedData != undefined) {
                try {
                    let token = "?" + Object.keys(tokenDecodedData).map(key => key + '=' + tokenDecodedData[key]).join('&');

                    if (!token.includes("organization_id")) {
                        token += "&organization_id=" + authOrganization._id;
                    }

                    getRoomStatus(token).then(data => {
                        if (data.status == 1) {
                            if (data.join_status == true) {
                                // setWaitinStatus(true)
                                clearTimeout(waitTimer)

                                setTimeout(function () {
                                    window.location.reload()
                                }, 6000)
                            }
                        }
                    })
                } catch (e) {
                    console.log("error waiting", e)
                }
            }
        }, API_STUDENT_WAIT_INTERVAL);
    }

    /**
     * Implements the React Components's render method.
     *
     * @inheritdoc
     */

    redirectToHome = () => {
        let location = window.location.origin;
        window.location.href = location;
    }



    render() {
        const { teacherDetail } = this.state;
        return (
            <div className='premeeting-screen waiting student-waiting'
                id='lobby-screen'>
                <div className="student-waiting-message">{
                    messages.studentWaitingMessage
                }</div>
            </div>);
    }
}

function mapStateToProps(state) {
    return {
        tokenDecodedData: state[FEATURE_CUSTOM_REDUX].tokenDecodedData,
        authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
        roomName: state['features/base/conference'].room
    }
}

export default connect(mapStateToProps)(StudentWaitingPage);
